const REGEX = {
  ALL: /^[-+*=~`^%$&#<>{}!?,;|"']+$/,
  NATIONAL_CODE: /^[0-9\\u0660-\\u0669\\u06F0-\\u06F9]{10}$/,
  PASSWORD: /^[0-9\u0660-\u0669\u06F0-\u06F9A-Za-z_@<>]$/,
  PLATE: /^[0-9\u0660-\u0669\u06F0-\u06F9]{9}$/,
  NUMBER: /^[0-9\u0660-\u0669\u06F0-\u06F9]+$/,
  STR_NUM_en: /^[0-9A-Za-z ]$/,
  STR_NUM_fa:
    /^[\u0660-\u0669\u06F0-\u06F9\u0621-\u0628\u062A-\u063A\u0641-\u0642\u0644-\u0648\u064E-\u0651\u0655\u067E\u0686\u0698\u06A9\u06AF\u06BE\u06CC\u06D5 ]+$/,
  STRING_fa_en:
    /^[0-9\u0660-\u0669\u06F0-\u06F9\u0621-\u0628\u062A-\u063A\u0641-\u0642\u0644-\u0648\u064E-\u0651\u0655\u067E\u0686\u0698\u06A9\u06AF\u06BE\u06CC\u06D5 ]+$/,
  PHONE:
    /^([0\u0660\u06F9])([9\u0669\u06F9])[0-9\u0660-\u0669\u06F0-\u06F9]{9}$/,
  TEL: /^([0\u0660\u06F9])([1-8\u0661-\u0668\u06F1-\u06F8])[0-9\u0660-\u0669\u06F0-\u06F9]{9}$/,
  STRING_fa:
    /^[\u0621-\u0628\u062A-\u063A\u0641-\u0642\u0644-\u0648\u064E-\u0651\u0655\u067E\u0686\u0698\u06A9\u06AF\u06BE\u06CC\u06D5 ]+$/,
  ADDRESS:
    /^[0-9,،()_+-/\u0660-\u0669\u06F0-\u06F9\u0621-\u0628\u062A-\u063A\u0641-\u0642\u0644-\u0648\u064E-\u0651\u0655\u067E\u0686\u0698\u06A9\u06AF\u06BE\u06CC\u06D5 ]+$/,
  REPAIR_NUM: /^[0-9\u0660-\u0669\u06F0-\u06F9]{10}$/,
};

export { REGEX };
